import React, { useState, useEffect, useRef, useLayoutEffect, useMemo } from 'react'
import './Home.css'
import './Mobile__Home.css'
import {images} from '../../data/Carousel__Images.js'
import {Gallery__Images} from '../../data/Data__Gallery.js'
import LightBox from '../../Components/LightBox/LightBox.js'
import MainButton from '../../Components/MainButton/MainButton'
import {motion} from 'framer-motion/dist/framer-motion'
import {options} from '../../Components/options'

function Home() {
    let [current, setCurrent] = useState(1);
    let [CurrentDetails, setCurrentDetails] = useState(0);
    let [transitionX, setTransitionX] = useState(0);
    let [modal, setModal] = useState(false);
    const containerRef = useRef();
    const lastImage = document.getElementById('bg-image0');
    const time = 3000
    let [resizeWidth, setResizeWidth] = useState(window.innerWidth)
    useEffect(() => {

        window.addEventListener('resize', () => {
            setResizeWidth(window.innerWidth)
        })
      
        let timer = setInterval(() => {
            control('next')
            setTransitionX(resizeWidth * (current + 1));
        }, time);
        
      return () => {
        clearInterval(timer)
        window.removeEventListener('resize', () => {
            setResizeWidth(window.innerWidth)
          })
      }
    }, [current, resizeWidth])


    const slides = useMemo(() => {
       const  Images = images.map((image, index) => (
            <img loading="lazy" src={images[index].imagePath} id={`bg-image${images[index].id}`} className='bg-image' key={images[index].id} alt={images[index].alt}  />
       ))

        Images.unshift(<img loading="lazy" id="image_gallery" src={images[0].imagePath} id={`bg-image${images.length + 2}`} key={images.length + 2} className='bg-image' alt={images[images.length - 1].alt}  /> )
       Images.push(<img loading="lazy" src={images[images.length - 1].imagePath} id={`bg-image${images.length + 1}`} key={images.length + 1} className='bg-image' alt={images[images.length - 1].alt} />)
        console.log(Images)
        return [
            ...Images
        ]
        /*  */
    },[])

    function control(mode) {
        if(mode === "next"){
            if( current >= 3) {
                setCurrent(0);
            }
            else{
                setCurrent((prevCurrent) => current + 1);
            }
        }
        
        else if(mode === 'prev') {
            if(current <= 0) {
                setCurrent(images.length - 1);
            }
            else{
                setCurrent(0);
            }
        }
        
    }

    function transitionEnd() {
        lastImage.style="transition:none;"
        setCurrent(0)
    }

    useLayoutEffect(() => {
        setTransitionX(resizeWidth * current)
    }, [resizeWidth])

    function modalBox(e) {
        if(!modal) {
            setCurrentDetails(e.target.id)
            setModal(true)
        }
        else {
            setCurrentDetails(0)
            setModal(false)
        }
    }
    return (
        
        <motion.div
        initial={options.initial}
        animate={options.animate}
        exit={options.exit}
        onAnimationComplete={() => { window.scrollTo(0,0)}}
        className="Home__Container">
            <section id="section-1-hero" className="section1__hero">
                
                <div className="slider__container" ref={containerRef} id="slide" style={{...{transform: `translateX(-${transitionX+'px'})`}, ...{width: resizeWidth}} }>
                            {
                                slides
                            }
                </div>

                <div className="row-hero-1">

                    <div className="row-hero-2 section1__textContainer" >
                        <h1 className="col-hero-1">Hi,<br /> I'm Nick <br /> Web Developer</h1>

                        <div className="col-hero-2 paragraph-container">
                            <p>Front-End | Back-End Developer</p>
                        </div>

                        <MainButton path={"/Contact"} title={"Contact Me!"} />
                    </div>

                <div className="row-hero-3 bottom-gradient"></div>
                </div>
            
            </section>

            <section id="section-2-portfolio" className="section-2 portfolio">
                <div className="row-portfolio-1">

                    <div className="row-portfolio-3 section2-content-container">
                        <div className="col-portfolio-1 section2-text-container">
                            <h2>Portfolio</h2>
                        </div>

                        <div className="section2-text-container col-portfolio-2">
                            <p>
                                Projects that i have made in the past. Are the ones Completed below. More are coming soon. Experimenting, Some projecgts are completed using
                                Vue.js, Wordpress, and of course React.js. This site was created using React.js. Having a solid foundation on HTML, JAVASCRIPT and CSS.
                            </p>
                        </div>
                    </div>

                </div>

            </section>

            <section id="section-3-gallery">

                <div className="gallery row-3">

                    {
                        Gallery__Images.map((project, index) => (
                            (
                                <div key={`col-${index}`} id={project.Header} className="gallery-img col-3" >
                                    <img id = "image_gallery" loading="lazy" src={project.src} data-src={`image ${index}`} key={`img-${index}`} alt={project.alt} style={{width:resizeWidth}} />
                                    <button key={`btn${index}`} className="project__name__Wrapper" id={index} onClick={(e) => modalBox(e)}> {project.Header} </button>
                                </div>
                            )
                        ))
                    }
                   
                </div>
            </section>
            <LightBox modal={modal} setModal={setModal} CurrentDetails={CurrentDetails} data={Gallery__Images} />
            <section id="section-4-About">
                <div className="row-1-about left">
                    <div className="col-1-about section4__header">
                        <h2> About Me </h2>
                    </div>

                    <div className="col-2-about section4__paragraph">

                        <p>
                            &nbsp; An inspired and creative new web developer. 
                            Willing to work alongside Web developers and other IT 
                            Professionals. As well as able to be self-sufficient 
                            alone. Building, learning and deploying web pages. 
                            provide various solutions to front-end and back-end 
                            problems. Designed new projects and improved past ones. 
                            Seeking improvement as a Web Developer is a rewarding 
                            experience.  Along with having fun and pride in the 
                            projects designed, to the coding process. Each project 
                            completed is an invaluable learning experience and 
                            satisfying feeling of achievement and pride. For more 
                            projects yet to come. I am looking forward to the team I 
                            will be working with.
                        </p>

                        <p>
                        having a natural curiosty for the world. Along with the passion
                    for learning. Is my core of <span className="tag">me</span>. From my work Ethics, lifestyle, 
                    and carrer. To my passion, hardwork, and determination. With having a curious mind i have always 
                    been hard on myself. When i failed to understand questions/topics/ect. Which is both a weakness and strength. 
                    While having a passion for learning with an inquisitive mind. Can be a useful or helpful to have in my field. 
                        </p>

                        <p>
                        I take it to extreme measures. If i failed to understand a problem my inquisitive mind turns to fustration and cloudy. 
                    However, i have been taking steps, through the use of research. To find a solution to my problems. The first step was to 
                    analyze the problem. Now i am working on improving myself to be a better Application Developer.
                        </p>


                    </div>

                </div>

                <div className="row-2-about right About__Me">
                    <h2>HTML</h2>
                    <h2>Css</h2>
                    <h2>Javascript</h2>
                    <h2>Node.js</h2>
                    <h2>Express.js</h2>
                    <h2>Vue.js</h2>
                    <h2>Git</h2>
                    <h2>GitHub</h2>
                    <h2>SEO</h2>
                    <h2>Object Oriented Programming</h2>
                </div>

            </section>
            <section id="section-5-Hobbies">
                <div className="row-1-Hobbies">
                    <div className="section4__header">
                        <h2> My Hobbies </h2>
                    </div>

                    <div className="section4__paragraph">

                        <p>
                            An inspired and creative new web developer. 
                            Willing to work alongside Web developers and other IT 
                            Professionals. As well as able to be self-sufficient 
                            alone. Building, learning and deploying web pages. <br/> <br/>
                            provide various solutions to front-end and back-end 
                            problems. Designed new projects and improved past ones. 
                            Seeking improvement as a Web Developer is a rewarding 
                            experience.  Along with having fun and pride in the 
                            projects designed, to the coding process. <br/> <br/> Each project 
                            completed is an invaluable learning experience and 
                            satisfying feeling of achievement and pride. For more 
                            projects yet to come. I am looking forward to the team I 
                            will be working with.
                        </p>

                    </div>

                </div>

                <div className="row-2-Hobbies My__Hobbies">
                    <h2>Shrimp Keeping</h2>
                    <h2>Video Games</h2>
                    <h2>Learning</h2>
                    <h2>Coding</h2>
                    <h2>Playing Guitar</h2>
                    <h2>Reading</h2>
                </div>

            </section>

            <section id="section-6-recentWork">
                <div className="row-1-recentWork"> 
                    <div className="col-1-recentWork">
                        <h2>Recent work</h2>
                        <p>Here is some of my most recent work with other clients</p>
                    </div>
                    <div className="col-2-recentWork">
                        <img loading="lazy" src={require('../../img/cherryblossomscreations.svg').default} alt="cherryblossomscreations logo" />
                        <img loading="lazy" src={require('../../img/greenstone.svg').default} alt="greenstone logo" />
                        <img loading="lazy" src={require('../../img/unlabeled.webp').default} alt="unlabeled elite ent logo" />
                    </div>
                </div>
            </section>
            <section id="section-7-conatct" className="contact__me__container">
                <div className="section-7-conatct-container">
                    <div className="row-1-contact">
                        <div className="col-1 contact_wrapper">
                            <h2>Contact me!</h2>
                            <p className="contact_text margin__bottom__top">
                                Have an questions about me, my projects, or a comment? Please leave an email for me.
                                And i will answer as soon as i can. Thank you!
                            </p>
                            <p className="contact_text margin__bottom__top">
                                <span>Email:</span> d.gaona1994@gmail.com
                            </p>
                            <p className="contact_text margin__bottom__top">
                                <span>Phone:</span> (956) 703-4247
                            </p>
                            <p className="contact_text margin__bottom__top">
                                <span>Days Available:</span> Mon-Fri 1pm - 5pm
                            </p>
                            <p className="contact_text margin__bottom__top">
                                <span>Location:</span> McAllen, Tx
                            </p>
                            <div className="button-container">
                            <MainButton path={"/Contact"} title={"Contact Me!"} />
                            </div>
                        </div>
                    </div>

                    <div className="row-2-contact">
                    <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1TcZdRI8Ek7tymKRE6UY7mt1whly2lAtJ&ehbc=2E312F" width="100%" height="100%"></iframe>
                    </div>
                </div>
            </section>
        </motion.div>
    )
}

export default Home
